import { render, staticRenderFns } from "./QOrganizaciones.vue?vue&type=template&id=a99861fc"
import script from "./QOrganizaciones.vue?vue&type=script&lang=js"
export * from "./QOrganizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports